import Seo from "@/components/Seo";
import Reveal from "@/components/Reveal";
import { Link } from "react-router-dom";

export default function Privacy() {
  return (
    <>
      <Seo
        title="Privacy | Bioregional Ventures"
        description="How Bioregional Ventures handles the details you share through the contact form."
      />

      <section className="max-w-3xl mx-auto px-6 md:px-10 pt-16 md:pt-24 pb-20 md:pb-28">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.15em] text-ochre-dark mb-4">Privacy</p>
          <h1 className="font-serif text-4xl md:text-5xl tracking-tight leading-tight text-charcoal" data-testid="privacy-heading">
            Privacy note
          </h1>

          <div className="mt-10 space-y-8 text-base leading-relaxed text-charcoal/90" data-testid="privacy-content">
            <div>
              <h2 className="font-serif text-2xl text-charcoal mb-3">What we collect</h2>
              <p>
                If you use the contact form, we collect the details you provide: your name, email
                address, and — if you choose to share them — your organisation, location and a
                description of what you are exploring.
              </p>
            </div>
            <div>
              <h2 className="font-serif text-2xl text-charcoal mb-3">How it is used</h2>
              <p>
                These details are used only to read and respond to your enquiry. They are stored
                securely and are not sold, shared with third parties for marketing, or added to a
                mailing list.
              </p>
            </div>
            <div>
              <h2 className="font-serif text-2xl text-charcoal mb-3">Tracking and cookies</h2>
              <p>
                This site does not use marketing cookies or third-party advertising trackers.
              </p>
            </div>
            <div>
              <h2 className="font-serif text-2xl text-charcoal mb-3">Your details</h2>
              <p>
                If you would like a copy of the details you have sent us, or would like them
                deleted, let us know through the{" "}
                <Link
                  to="/contact"
                  data-testid="privacy-contact-link"
                  className="underline decoration-ochre underline-offset-4 text-ochre-dark hover:text-charcoal transition-colors duration-300"
                >
                  contact form
                </Link>{" "}
                and we will take care of it.
              </p>
            </div>
          </div>
        </Reveal>
      </section>
    </>
  );
}
